import { render, staticRenderFns } from "./prediction.vue?vue&type=template&id=2c75c520&scoped=true&"
import script from "./prediction.vue?vue&type=script&lang=js&"
export * from "./prediction.vue?vue&type=script&lang=js&"
import style0 from "./prediction.vue?vue&type=style&index=0&id=2c75c520&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c75c520",
  null
  
)

export default component.exports